import { Module } from 'vuex'
import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'
import { ApiState } from './types'
import { RootState } from '../types'

export const state: ApiState = {
  accessToken: null,
  shouldAccept: false,
  errors: {
    registeruserconsent: false
  }
}

const namespaced = true

export const API: Module<ApiState, RootState> = {
  namespaced,
  actions,
  mutations,
  getters,
  state
}
